'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$AboutAppPage$() {
}
export { $c_Lmealorama_AppRouter$AboutAppPage$ as $c_Lmealorama_AppRouter$AboutAppPage$ };
$p = $c_Lmealorama_AppRouter$AboutAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$AboutAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$AboutAppPage$() {
}
export { $h_Lmealorama_AppRouter$AboutAppPage$ as $h_Lmealorama_AppRouter$AboutAppPage$ };
$h_Lmealorama_AppRouter$AboutAppPage$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-390957021);
});
$p.m = (function() {
  return "AboutAppPage";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "AboutAppPage";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$AboutAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$AboutAppPage$, "mealorama.AppRouter$AboutAppPage$", ({
  Fm: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$AboutAppPage$ as $d_Lmealorama_AppRouter$AboutAppPage$ };
var $n_Lmealorama_AppRouter$AboutAppPage$;
function $m_Lmealorama_AppRouter$AboutAppPage$() {
  if ((!$n_Lmealorama_AppRouter$AboutAppPage$)) {
    $n_Lmealorama_AppRouter$AboutAppPage$ = new $c_Lmealorama_AppRouter$AboutAppPage$();
  }
  return $n_Lmealorama_AppRouter$AboutAppPage$;
}
export { $m_Lmealorama_AppRouter$AboutAppPage$ as $m_Lmealorama_AppRouter$AboutAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-About-App-Page$.js.map
